import Icon from '@/components/ui/AppIcon';

interface GuaranteeItem {
  id: string;
  icon: string;
  title: string;
  description: string;
}

const guarantees: GuaranteeItem[] = [
  {
    id: 'satisfaction',
    icon: 'HandThumbUpIcon',
    title: '100% tilfredsgaranti',
    description: 'Ikke fornøyd? Vi sender gullet tilbake kostnadsfritt. Ingen spørsmål stilt.',
  },
  {
    id: 'price',
    icon: 'CurrencyDollarIcon',
    title: 'Åpen vurdering uten forpliktelser',
    description: 'Du står fritt til å takke nei etter vurdering.',
  },
  {
    id: 'security',
    icon: 'LockClosedIcon',
    title: 'Sikkerhetsgaranti',
    description: 'Fullstendig forsikring under hele prosessen. Din trygghet er vår prioritet.',
  },
  {
    id: 'speed',
    icon: 'BoltIcon',
    title: 'Rask utbetaling',
    description: 'Pengene på konto innen 24 timer etter akseptert tilbud. Garantert.',
  },
];

const GuaranteeSection = () => {
  return (
    <section className="bg-background py-12 lg:py-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-headline text-3xl font-bold text-foreground lg:text-4xl">
            Våre garantier til deg
          </h2>
          <p className="mt-4 font-body text-lg text-muted-foreground lg:text-xl">
            Vi står bak våre løfter med konkrete garantier
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2">
          {guarantees.map((guarantee) => (
            <div
              key={guarantee.id}
              className="flex space-x-4 rounded-lg bg-card p-6 shadow-md transition-transform duration-300 hover:scale-105 lg:p-8"
            >
              <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-success/10">
                <Icon name={guarantee.icon as any} size={28} variant="solid" className="text-success" />
              </div>
              <div>
                <h3 className="font-headline text-xl font-semibold text-foreground lg:text-2xl">
                  {guarantee.title}
                </h3>
                <p className="mt-3 font-body text-base text-muted-foreground">
                  {guarantee.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg bg-success/10 p-8 lg:p-12">
          <div className="text-center">
            <Icon name="ShieldCheckIcon" size={64} variant="solid" className="mx-auto mb-6 text-success" />
            <h3 className="font-headline text-2xl font-bold text-foreground lg:text-3xl">
              Risikofri prosess fra start til slutt
            </h3>
            <p className="mx-auto mt-4 max-w-3xl font-body text-lg text-muted-foreground">
              Vi forstår at det kan være nervøst å selge verdifulle eiendeler. Derfor har vi bygget vår tjeneste rundt din trygghet og tilfredshet. Du tar ingen risiko når du velger Gullklar.
            </p>
            <div className="mt-8 flex flex-col items-center justify-center space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
              <a
                href="#calculator"
                className="flex items-center space-x-2 rounded-lg bg-accent px-8 py-4 font-cta text-base font-semibold text-accent-foreground shadow-cta transition-all duration-250 hover:bg-accent/90 lg:text-lg"
              >
                <Icon name="CalculatorIcon" size={20} variant="solid" />
                <span>Beregn verdi nå</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          <div className="rounded-lg bg-card p-6 text-center">
            <div className="font-headline text-3xl font-bold text-primary">Tydelig prosess</div>
            <div className="mt-2 font-body text-sm text-muted-foreground">Fra start til slutt</div>
          </div>
          <div className="rounded-lg bg-card p-6 text-center">
            <div className="font-headline text-3xl font-bold text-primary">Sikker håndtering</div>
            <div className="mt-2 font-body text-sm text-muted-foreground">Forsvarlige rutiner</div>
          </div>
          <div className="rounded-lg bg-card p-6 text-center">
            <div className="font-headline text-3xl font-bold text-primary">God dialog</div>
            <div className="mt-2 font-body text-sm text-muted-foreground">Personlig oppfølging</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuaranteeSection;